import React, { useState, useCallback, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles, Theme } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import { Avatar } from "@material-ui/core";
import ListItemText from "@material-ui/core/ListItemText";
import { useHistory } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../app/store";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import {
  selectTargetUser,
  selectFollowList,
  setFollowAccount,
  fetchAsyncGetSelectFollowList,
  selectSelectedUser,
  selectSelectUserFollowList,
} from "../home/homeSlice";

import {
  fetchAsyncGetUsersProfile,
  fetchAsyncLoginUser,
  selectLoginUser,
  fetchAsyncGetLoginProfile,
  selectLoginUserProfile,
} from "../auth/authSlice";

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    margin: theme.spacing(3, 4),
    display: "flex",
    flexDirection: "column",
  },
  root: {
    borderRadius: "30px",
  },
  backgroundColor: {
    backgroundColor: "#F1F9FF",
    height: "100vh",
  },
  categoryContainer: {
    flexDirection: "unset",
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    alignItems: "center",
    justifyContent: "space-between",
  },
  listContainer: {
    margin: theme.spacing(0, 1),
    backgroundColor: "#fff",
    height: "100vh",
    borderRadius: "5px",
  },
  listBorder: {
    borderBottom: "1px solid #f1f1f1",
    paddingBottom: 6,
    paddingTop: 6,
  },
  undefinedUser: {
    textAlign: "center",
    marginTop: theme.spacing(3),
  },
  label: {
    "& .MuiFormControlLabel-label": {
      fontSize: 12,
    },
  },
  submit: {
    fontSize: 12,
    height: 35,
    color: "#fff",
    backgroundColor: "#2699FB",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    alignItems: "center",
  },
  headerBack: {
    paddingLeft: theme.spacing(3),
  },
  headerText: {
    width: "100%",
    textAlign: "center",
    paddingRight: 48,
    fontSize: 14,
  },
  iconBtn: {
    color: "#fff",
    backgroundColor: "#00acc1",
    fontSize: 10,
  },
}));

const Search = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch: AppDispatch = useDispatch();
  const followList = useSelector(selectFollowList);
  const loginUser = useSelector(selectLoginUser);
  const loginUserProfile = useSelector(selectLoginUserProfile);
  const selectedUser = useSelector(selectSelectedUser);
  const selectUserFollowList = useSelector(selectSelectUserFollowList);
  //画面遷移時にフォローユーザは存在しませんを非表示にする
  const [isLoading, setIsLoading] = useState(false);
  //検索結果のリスト押下時　対象ユーザのprofileで画面表示
  const goProfile = useCallback(
    async (id: number, user: string) => {
      //画面遷移時にフォローユーザは存在しませんを非表示にする
      await setIsLoading(true);

      await dispatch(selectTargetUser({ user_profile: id, username: user }));
      await dispatch(fetchAsyncGetUsersProfile(id));
      //フォローページからの遷移だと判別（戻るボタンで正常に戻れるようにする）
      await dispatch(setFollowAccount(true));
      await history.push("/home/profile");
      await dispatch(fetchAsyncGetSelectFollowList(id));
      await setIsLoading(false);
    },
    [history, dispatch]
  );

  //戻るボタン(selectedUserをリセットする)
  const backProfile = useCallback(() => {
    history.push("/home/profile");
  }, [history, dispatch]);

  //画面初期表示時、ログインユーザの情報を取得し格納
  useEffect(() => {
    loginUser.id === 0 && dispatch(fetchAsyncLoginUser());
  }, [dispatch]);

  //プロフィールデータが取得できていない場合、ログインユーザのプロフィールを取得
  useEffect(() => {
    loginUserProfile.user_profile === 0 &&
      dispatch(fetchAsyncGetLoginProfile());
  }, [loginUser, dispatch]);

  return (
    <Grid container>
      <Grid item xs={12} className={classes.backgroundColor}>
        <div className={classes.header}>
          <div className={classes.headerBack}>
            <ArrowBackIcon onClick={backProfile} />
          </div>
          <div className={classes.headerText}>フォロー中のユーザー</div>
        </div>
        <div className={classes.listContainer}>
          <List dense>
            {selectedUser.user_profile === 0
              ? // ログインユーザの情報
                followList.count === 0 && (
                  <li className={classes.undefinedUser}>
                    フォロー済みのユーザーは存在しません
                  </li>
                )
              : // セレクトユーザの情報
                selectUserFollowList.count === 0 &&
                isLoading === false && (
                  <li className={classes.undefinedUser}>
                    フォロー済みのユーザーは存在しません
                  </li>
                )}

            {selectedUser.user_profile === 0
              ? followList.count > 0 &&
                followList.results.map((user) => (
                  <ListItem
                    className={classes.listBorder}
                    key={user.id}
                    button
                    onClick={() =>
                      goProfile(
                        user.follow_target_user_profile,
                        user.follow_target_username
                      )
                    }
                  >
                    <ListItemAvatar>
                      <Avatar
                        src={
                          user?.follow_target_img
                            ? user?.follow_target_img
                            : undefined
                        }
                      />
                    </ListItemAvatar>
                    <ListItemText primary={user.follow_target_username} />
                  </ListItem>
                ))
              : selectUserFollowList.count > 0 &&
                selectUserFollowList.results.map(
                  (user) =>
                    user.id !== 0 && (
                      <ListItem
                        className={classes.listBorder}
                        key={user.id}
                        button
                        onClick={() =>
                          goProfile(
                            user.follow_target_user_profile,
                            user.follow_target_username
                          )
                        }
                      >
                        <ListItemAvatar>
                          <Avatar
                            src={
                              user?.follow_target_img
                                ? user?.follow_target_img
                                : undefined
                            }
                          />
                        </ListItemAvatar>
                        <ListItemText primary={user.follow_target_username} />
                      </ListItem>
                    )
                )}
          </List>
        </div>
      </Grid>
      <Grid item></Grid>
    </Grid>
  );
};

export default Search;
